export const APP_BASE_URL = "https://test-automation-123.vercel.app";
export const APP_PREDICT_URL = `${APP_BASE_URL}/predict`;

export const API_BASE_URL = "https://test-automation-12.onrender.com";

export const API_ENDPOINTS = {
  login: `${API_BASE_URL}/login`,
  register: `${API_BASE_URL}/register`,
  predict: `${API_BASE_URL}/predict`
};
